import { ClerkLoaded, ClerkLoading } from "@clerk/clerk-react";

export function ClerkGate({ children }) {
  return (
    <>
      <ClerkLoading>
        <div
          style={{
            width: "100%",
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "32px",
          }}
        ></div>
      </ClerkLoading>

      <ClerkLoaded>{children}</ClerkLoaded>
    </>
  );
}
